export const GET_WEIGHT_DISCREPANCY_DATA_SUCCESS = "GET_WEIGHT_DISCREPANCY_DATA_SUCCESS";
export const GET_WEIGHT_DISCREPANCY_DATA_REQUEST = "GET_WEIGHT_DISCREPANCY_DATA_REQUEST";
export const GET_WEIGHT_DISCREPANCY_DATA_FAILURE = "GET_WEIGHT_DISCREPANCY_DATA_FAILURE";
export const GET_WEIGHT_DISCREPANCY_DATA_RESET = "GET_WEIGHT_DISCREPANCY_DATA_RESET";
export const getWeightDiscrepancyDataSuccess = (payload) => ({
    type: GET_WEIGHT_DISCREPANCY_DATA_SUCCESS,
    payload,
});
export const getWeightDiscrepancyDataRequest = (payload) => ({
    type: GET_WEIGHT_DISCREPANCY_DATA_REQUEST,
    payload,
});
export const getWeightDiscrepancyDataFailure = (payload) => ({
    type: GET_WEIGHT_DISCREPANCY_DATA_FAILURE,
    payload,
});
export const getWeightDiscrepancyDataReset = () => ({
    type: GET_WEIGHT_DISCREPANCY_DATA_RESET,
});
